import { useAuth } from '@/lib/auth/use-auth.js';
import { tokens } from '@/lib/tokens.js';
import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_admin')({
  component: AdminLayout,
});

function ForbiddenPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '1rem',
        color: tokens.colors.textMutedDark,
        fontFamily: tokens.font.sans,
      }}
    >
      <span style={{ fontSize: '3rem' }}>🚫</span>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: tokens.colors.textDark }}>
        Access denied
      </h1>
      <p>You do not have permission to access the admin panel.</p>
    </div>
  );
}

function LoadingSpinner() {
  return (
    <output
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        color: tokens.colors.textMutedDark,
        fontFamily: tokens.font.sans,
      }}
      aria-label="Loading"
    >
      Loading…
    </output>
  );
}

function AdminLayout() {
  const { status, user } = useAuth();
  const navigate = useNavigate();

  // W-7: unauthenticated users get redirected to /login (consistent with ProtectedRoute)
  useEffect(() => {
    if (status === 'unauthenticated') {
      void navigate({ to: '/login' });
    }
  }, [status, navigate]);

  if (status === 'idle' || status === 'authenticating' || status === 'unauthenticated') {
    return <LoadingSpinner />;
  }

  if (user === null || (!user.isAdmin && !user.isSuperAdmin)) {
    return <ForbiddenPage />;
  }

  return <Outlet />;
}
